/* eslint-disable react/require-default-props */
import { CheckboxProps, Switch } from '@material-ui/core';
import { useController } from 'react-hook-form';
import { useFieldControllerContext } from './FieldControllerContext';

export type FieldCheckboxProps<T> = CheckboxProps & {
  falseValue?: T;
  trueValue?: T;
};

const FieldSwitch = <T extends unknown = boolean>({
  falseValue = false as T,
  trueValue = true as T,
  readOnly,
  onChange: onChangeProp,
  ...props
}: FieldCheckboxProps<T>) => {
  const { name } = useFieldControllerContext();

  const {
    field: { onBlur, onChange, ref, value },
  } = useController({ name });

  return (
    <Switch
      ref={ref}
      onBlur={onBlur}
      checked={value === trueValue}
      onChange={(e, checked) => {
        if (!readOnly) {
          onChange(checked ? trueValue : falseValue);
          onChangeProp?.(e, checked);
        }
      }}
      {...props}
    />
  );
};

export default FieldSwitch;
